import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function CostGuideHero() {
  return <section id="costguidehero" data-nav="light" className="relative overflow-hidden bg-background py-16 text-foreground md:py-24 lg:py-28 isolate">
      {/* Decorative ambient background planes */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-24 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-chart-1/10 blur-3xl" />
        <div className="absolute right-10 top-1/3 h-64 w-64 rounded-full bg-secondary/80 blur-2xl" />
        <div className="absolute -bottom-20 left-10 h-72 w-72 rounded-full bg-chart-3/15 blur-3xl" />
      </div>

      <div className="container mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-border/80 bg-card/60 p-8 shadow-sm backdrop-blur-md md:p-12 lg:p-16">
          {/* Breadcrumb Navigation */}
          <div className="mb-6">
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/" className="text-muted-foreground transition-colors hover:text-foreground">
                      Home
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <span className="text-muted-foreground">Resources</span>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="font-medium text-foreground">
                    Remodeling Cost Guide
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {/* Heading and Intro */}
          <div className="max-w-3xl space-y-6">
            <h1 className="font-serif text-4xl font-semibold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
              Decatur Remodeling Cost Guide
            </h1>
            <p className="font-default text-lg leading-relaxed text-muted-foreground sm:text-xl">
              Understand real-world investment ranges for kitchens, master suites, whole-home updates, and outdoor additions across Decatur and surrounding historic neighborhoods.
            </p>
          </div>
        </div>
      </div>
    </section>;
}